import { QuestionProps } from '@/models/Question';

import IntegerQuestionType from './Integer';

function Hours({ question }: { question: QuestionProps }) {
  return <IntegerQuestionType question={question} />;
}

export default Hours;
